export default __webpack_public_path__ + "static/media/98-09_header_invoice.93a52a27.png";